module.exports = __webpack_public_path__ + "img/hotel-santa-justa.14ba2932.jpg";